import React from 'react'
import { connect } from 'react-redux'
import 'moment/locale/pt-br'
import '../../css/components/react-datepicker.css';
import Titulo from '../comum/Titulo';
import ExportarCsv from '../comum/ExportarCSV';
import { tipoRepasseVenda } from '../../util/constantsUtil';
import qs from 'qs';

export class PainelResumoRepasse extends React.Component {
    constructor(props) {
        super(props);
    }

    exibirRelatorio() {
        const tipoRepasse = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
        const repasseEmpresa = tipoRepasse.tipo === tipoRepasseVenda.empresa.nome;
        const repasseVendedor = tipoRepasse.tipo === tipoRepasseVenda.vendedor.nome;
        const repasseImposto = tipoRepasse.tipo === tipoRepasseVenda.imposto.nome;
        return (
            <React.Fragment>
                <div className="d-flex flex-row-reverse mb-4 mr-4">
                    <div className='pull-right'>
                        <ExportarCsv dadosCsv={'teste'}
                            nomeArquivo={'teste'} />
                    </div>
                </div>
                <div className='table-responsive'>
                    <table className="table table-striped table-bordered" style={{ backgroundColor: '#FFF' }}>
                        <thead>
                            <tr className='border'>
                                <th scope="col">N° Bilhete</th>
                                {repasseEmpresa ? <th scope="col">Empresa</th> : ''}
                                {repasseVendedor ? <th scope="col">Vendedor</th> : ''}
                                {repasseImposto ? <th scope="col">Grupo</th> : ''}
                                <th scope="col">Total tx Serviço</th>
                                <th scope="col">Total Comissão</th>
                                <th scope="col">Total Comissão Agente</th>
                                <th scope="col">Total Imposto</th>
                                <th scope="col">Total Custo Cancelamento</th>
                                <th scope="col">Total Faturado</th>
                                <th scope="col">Total Repasse</th>
                            </tr>
                        </thead>
                            {this.props.cadastroRepasseVenda && this.props.cadastroRepasseVenda.map((it, index) => <tbody key={index}>
                                <tr>
                                    <td>
                                        <span>{it.reservaId}</span>
                                    </td>
                                    <td>
                                        {repasseEmpresa ? <span>{it.nomeEmpresa}</span> : ''}
                                        {repasseVendedor ? <span>{it.nomeUsuario}</span> : ''}
                                        {repasseImposto ? <span>{it.grupo}</span> : ''}
                                    </td>
                                    <td>
                                        <span>{Number(it.totalTaxaServico)
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}</span>
                                    </td>
                                    <td>
                                        <span>{Number(it.totalComissao)
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}</span>
                                    </td>
                                    <td>
                                        <span>{Number(it.totalComissaoAgente)
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}</span>
                                    </td>
                                    <td>
                                        <span>{Number(it.totalImposto)
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}</span>
                                    </td>
                                    <td>
                                        <span>{Number(it.totalCustoCancelamento)
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}</span>
                                    </td>
                                    <td>
                                    <span>{Number(it.valor + it.totalImposto + it.totalComissao)
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}</span>
                                    </td>
                                    <td>
                                    <span>{Number(repasseEmpresa ? it.valor - it.totalComissao - it.totalImposto : '' ||
                                            repasseVendedor ? it.totalComissao : '' ||
                                            repasseImposto ? it.totalImposto : '')
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}</span>
                                    </td>
                                </tr>
                        </tbody>)}
                    </table>
                </div>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className="container-padrao" style={{ height: '100%' }}>
                <Titulo texto="Repasse Venda" urlRetorno="/painel-repasse-venda" />
                <div className="lista-table mt-5">
                    {this.exibirRelatorio()}
                </div>
            </div>
        )
    }
}


export const mapStateToProps = (state) => {
    return {
        repasseVenda: state.repasseVenda,
        cadastroRepasseVenda: state.cadastroRepasseVenda || []
    }
};


export default connect(mapStateToProps,
    {}
)(PainelResumoRepasse)
